import request from '@/utils/request'

export function updateChestCfg(data) {
  return request({
    url: 'api/v1/chest/updateCfg',
    method: 'post',
    data: data
  })
}

export function getChestCfgList(data) {
  return request({
    url: 'api/v1/chest/getCfg',
    method: 'get',
    params: data
  })
}

export function getChestWeight(data) {
  return request({
    url: 'api/v1/chest/getChestWeightCfg',
    method: 'post',
    data: data
  })
}

export function exportChestWeight(data) {
  return request({
    url: 'api/v1/chest/exportChestWeightCfg',
    method: 'post',
    data: data
  })
}

export function importChestWeight(data) {
  return request({
    url: 'api/v1/chest/importChestWeightCfg',
    method: 'post',
    data: data
  })
}

